// src/services/ProjectService.js

import API from './api';

const ProjectService = {
    // Get all projects
    getAllProjects: async () => {
        try {
            const res = await API.get('/api/projects');
            return res.data;
        } catch (error) {
            console.error('Error getting all projects:', error.response?.data || error.message);
            throw error;
        }
    },

    // Get project by ID
    getProjectById: async (projectId) => {
        try {
            const res = await API.get(`/api/projects/${projectId}`);
            return res.data;
        } catch (error) {
            console.error('Error getting project:', error.response?.data || error.message);
            throw error;
        }
    },

    // Create new project
    createProject: async (projectData) => {
        try {
            console.log("createProject started");
            const res = await API.post('/api/projects', projectData);
            console.log("createProject", res.data)
            return res.data;
        } catch (error) {
            console.error('Error creating project:', error.response?.data || error.message);
            throw error;
        }
    },

    // Update project
    updateProject: async (projectId, projectData) => {
        try {
            const res = await API.put(`/api/projects/${projectId}`, projectData);
            return res.data;
        } catch (error) {
            console.error('Error updating project:', error.response?.data || error.message);
            throw error;
        }
    },

    // Delete project
    deleteProject: async (projectId) => {
        try {
            const res = await API.delete(`/api/projects/${projectId}`);
            return res.data;
        } catch (error) {
            console.error('Error deleting project:', error.response?.data || error.message);
            throw error;
        }
    },
    // Add this to src/services/ProjectService.js

    createProjectUpdate: async (projectId, updateData) => {
        try {
            const res = await API.post(`/api/projects/${projectId}/updates`, updateData);
            return res.data;
        } catch (error) {
            console.error('Error creating project update:', error.response?.data || error.message);
            throw error;
        }
    },
};



export default ProjectService;